import styles from './taskComponent.module.css'
import { TaskItem } from './TaskItem'

export const TaskList = ({
	tasks,
	setEditingTask,
	setConfirmDeleteId,
	staff,
}) => {
	return (
		<div className={styles.tasksCard}>
			<div className={styles.table}>
				<div className={`${styles.row} ${styles.head}`}>
					<div>Name</div>
					<div>Type</div>
					<div className={styles.actionsCol}>Actions</div>
				</div>
				{tasks.length === 0 && (
					<div className={styles.empty}>No tasks yet.</div>
				)}

				<div className={styles.tableBody}>
					{tasks.map((t) => (
						<TaskItem
							key={t._id}
							setEditingTask={setEditingTask}
							setConfirmDeleteId={setConfirmDeleteId}
							task={t}
							staff={staff}
						/>
					))}
				</div>
			</div>
		</div>
	)
}
